import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { apiGetEntitlements } from '../../core/redux/api/endpoints';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { IAppState } from '../../core/redux/IAppState';
import * as R from 'ramda';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { GuestDetails } from '../guestDetails';
import { updateGuest } from '../module';
import { QuickEntitlement } from './models';


const KEY_ACTION = ACTION_TYPE.GUEST_ENTITLEMENTS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GUEST_ENTITLEMENTS_REQUEST,
  ACTION_TYPE.GUEST_ENTITLEMENTS_RESPONSE,
  ACTION_TYPE.GUEST_ENTITLEMENTS_ERROR,
];


/**
 * Makes an action that can be dispatched to load a guest's list of entitlements which includes things like their
 * age bucket and IKON pass version.
 */
export const guestEntitlementsAction = (guest: GuestDetails) => makeApiAction(
  {
    method:   'GET',
    endpoint: state => apiGetEntitlements(guest.masterGuestId, state.selectedResort.resortAbbreviation),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { guest } })) as RsaaTypes,
    bailout:  state => !!getLoading(state, guest.masterGuestId, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<QuickEntitlement[]> = (state, action, error, isLoading, payload) => {
  const metaGuest = action.meta.guest;
  const guestId   = metaGuest.masterGuestId;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error, { guest: metaGuest });
  }

  const adjustedState = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  return updateGuest(adjustedState, guestId, R.assocPath([ 'entitlements' ], payload));
};


export const guestEntitlementsReducer = makeApiReducer<QuickEntitlement[]>(ACTIONS, KEY_ACTION, reducer);
